export default __webpack_public_path__ + "static/media/logo.6f3622b8.png";